import {TranslateLoader} from "@ngx-translate/core";
import {Observable} from "rxjs";
import { TranslationCacheService } from "./translation-cache.service";

export class ElisTranslatorLoaderFactory{
    static forModule(): any {

        return class CachedTranslateLoader implements TranslateLoader {
            constructor(
                private cacheService: TranslationCacheService
            ) {}

            getTranslation(lang: string): Observable<any> {
                return this.cacheService.getTranslation(lang);
            }
        };

    }
}